import { createSlice } from '@reduxjs/toolkit'
import { type AppState } from 'src/redux/app/app.store'

const HOLIDAY_ANIMATION_STORAGE_KEY = 'holidayAnimationEnabled'

interface HolidayAnimationState {
    isHolidayAnimationEnabled: boolean
}

const getInitialState = (): HolidayAnimationState => {
    const stored = localStorage.getItem(HOLIDAY_ANIMATION_STORAGE_KEY)
    return {
        isHolidayAnimationEnabled: stored === 'true',
    }
}

const initialState: HolidayAnimationState = getInitialState()

const holidayAnimationSlice = createSlice({
    name: 'holidayAnimation',
    initialState,
    reducers: {
        toggleHolidayAnimation(state) {
            const newState = { ...state, isHolidayAnimationEnabled: !state.isHolidayAnimationEnabled }
            localStorage.setItem(HOLIDAY_ANIMATION_STORAGE_KEY, String(newState.isHolidayAnimationEnabled))
            return newState
        },
    },
})

// Actions
export const { toggleHolidayAnimation } = holidayAnimationSlice.actions

// Selectors
export const selectIsHolidayAnimationEnabled = (state: AppState): boolean =>
    state.holidayAnimation.isHolidayAnimationEnabled

// Reducer
export const { reducer: holidayAnimationReducer } = holidayAnimationSlice
